import {
    LearnExperienceFrameDockSide,
    LearnExperienceState
} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/LearnExperienceState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {ResizeEvent, ResizePhase} from '@mintdata-wsp/wsp/ui/components/resizable/Resizer';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {Component} from 'react';

const styles = require('./LearnExperience.less');
const cx = classnames.bind(styles);

@observer
export class LearnExperience extends Component<any, any>
{
    private _elementRef:HTMLDivElement = null;
    private _size:number = 0;

    @bind
    private _onElementRef(elementRef:HTMLDivElement):void
    {
        this._elementRef = elementRef;
    }

    @bind
    private _handleResize(event:ResizeEvent):void
    {
        const {lx} = controllers.ui;
        const lxState:LearnExperienceState = lx.getState();

        if( event.phase === ResizePhase.Start )
        {
            const clientRect:ClientRect = this._elementRef.getBoundingClientRect();

            this._size = lxState.dockSide === LearnExperienceFrameDockSide.Left
            || lxState.dockSide === LearnExperienceFrameDockSide.Right
                ? clientRect.width
                : clientRect.height;
        }
        else if( event.phase === ResizePhase.Stop )
        {
            lxState.dockSize = this._size - (lxState.dockSide === LearnExperienceFrameDockSide.Left
            || lxState.dockSide === LearnExperienceFrameDockSide.Right
                ? event.deltaX
                : event.deltaY);
        }
    }

    public render():JSX.Element
    {
        const {lx} = controllers.ui;
        const lxState:LearnExperienceState = lx.getState();
        const {isActive, isVisible, learnAppUrl, bounds, dockSide, isOverlay} = lxState;

        return isActive && <div
            ref={this._onElementRef}
            className={cx('base', dockSide, {isVisible})}
            style={bounds}
        >
            {learnAppUrl && <iframe
                ref={lx.onIframeRef}
                src={learnAppUrl}
                className={cx('frame', {isOverlay})}
            />}
        </div>;
    }
}
